var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9854 0.5V4.0957H40.9551V0.5H45.3262V4.0957H55.4404V55.4404H0.5V4.0957H10.6133V0.5H14.9854ZM4.87109 50.8438H51.0684V19.4805H4.87109V50.8438ZM17.7207 22.7676L29.0195 34.8203L29.3398 35.1621L29.0195 35.5039L17.7207 47.5566L17.3555 47.9453L16.9912 47.5566L14.6211 45.0273L14.2998 44.6855L14.6211 44.3438L23.2275 35.1621L14.6211 25.9805L14.2998 25.6387L14.6211 25.2959L16.9912 22.7676L17.3555 22.3789L17.7207 22.7676ZM31.2061 22.7676L42.5049 34.8203L42.8252 35.1621L42.5049 35.5039L31.2061 47.5566L30.8408 47.9453L30.4756 47.5566L28.1055 45.0273L27.7852 44.6855L28.1055 44.3438L36.7129 35.1621L28.1055 25.9805L27.7852 25.6387L28.1055 25.2959L30.4756 22.7676L30.8408 22.3789L31.2061 22.7676ZM4.87109 14.8838H51.0684V8.69238H45.3262V12.2881H40.9551V8.69238H14.9854V12.2881H10.6133V8.69238H4.87109V14.8838Z",
    fill: "#077CA5",
    stroke: "#077CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewIcon);
export default __webpack_public_path__ + "static/media/RenewIcon.d241778dcad0fff593129aa2c5a98ad3.svg";
export { ForwardRef as ReactComponent };